import {store} from "../../index";
import {
  SET_ASSET_PURCHASER_ACQUISITION_EXPENSES,
  SET_STOCK_PURCHASER_ACQUISITION_EXPENSES
} from "./mutations";
import PurchaserAcquisitionExpenses , {
  AcquisitionLicensesTaxesPermitsAndFees,
  GeneralAcquisition,
  PrePaidAssetNeeded,
  WorkingCapitalNeededAtClosing
} from "../../../models/transactions/PurchaserAcquisitionExpenses";
import CustomField from "../../../models/CustomField";
import {SET_OWNER_FINANCING_STOCK_SALE_REPORT} from "../financials/mutations";
import OwnerFinancingStockSaleReport, {
  AccountsPayable, CurrentAssetsKeptBySeller, Financing, LiabilitiesAssumedByBuyer, OtherExpensesNeededToClose,
  SellingExpenses
} from "../../../models/transactions/OwnerFinancingStockSaleReport";



export const generatePurchaserAcquisitionExpenses = ({ purchaseAcquisitionExpensesType }) => (dispatch) => {
  const { stockPurchaserAcquisitionExpenses, assetPurchaserAcquisitionExpenses } = store.getState().acquisitionExpenses

  const actionType = purchaseAcquisitionExpensesType === "stock" ? (
    SET_STOCK_PURCHASER_ACQUISITION_EXPENSES
  ) : SET_ASSET_PURCHASER_ACQUISITION_EXPENSES

  const storedPurchaserAcquisitionExpenses = purchaseAcquisitionExpensesType === "stock" ? (
    stockPurchaserAcquisitionExpenses
  ) : assetPurchaserAcquisitionExpenses

  if (storedPurchaserAcquisitionExpenses) {
    dispatch({
      type: actionType,
      payload: new PurchaserAcquisitionExpenses({
        generalAcquisition: new GeneralAcquisition({
          ...storedPurchaserAcquisitionExpenses?.generalAcquisition
        }),
        acquisitionLicensesTaxesPermitsAndFees: new AcquisitionLicensesTaxesPermitsAndFees({
          ...storedPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees
        }),
        prePaidAssetsNeeded: new PrePaidAssetNeeded({
          ...storedPurchaserAcquisitionExpenses?.prePaidAssetsNeeded
        }),
        workingCapitalNeededAtClosing: new WorkingCapitalNeededAtClosing({
          ...storedPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing
        })
      })
    })

    return
  }

  dispatch({
    type: actionType,
    payload: new PurchaserAcquisitionExpenses({
      generalAcquisition: new GeneralAcquisition({
      }),
      acquisitionLicensesTaxesPermitsAndFees: new AcquisitionLicensesTaxesPermitsAndFees({
      }),
      prePaidAssetsNeeded: new PrePaidAssetNeeded({
      }),
      workingCapitalNeededAtClosing: new WorkingCapitalNeededAtClosing({
      })
    })
  })
}

export const updatePurchaserAcquisitionExpenses = ({ purchaserAcquisitionExpensesType }, {
  generalAcquisition,
  acquisitionLicensesTaxesPermitsAndFees,
  prePaidAssetsNeeded,
  workingCapitalNeededAtClosing
}) => (dispatch) => {
  const { stockPurchaserAcquisitionExpenses, assetPurchaserAcquisitionExpenses } = store.getState().acquisitionExpenses
  const storedPurchaserAcquisitionExpenses = purchaserAcquisitionExpensesType === "stock" ? ({
    ...stockPurchaserAcquisitionExpenses
  }) : { ...assetPurchaserAcquisitionExpenses }

  const actionType = purchaserAcquisitionExpensesType === "stock" ? (
    SET_STOCK_PURCHASER_ACQUISITION_EXPENSES
  ) : SET_ASSET_PURCHASER_ACQUISITION_EXPENSES

  const purchaserAcquisitionExpenses = new PurchaserAcquisitionExpenses({
    generalAcquisition: new GeneralAcquisition({
      ...storedPurchaserAcquisitionExpenses.generalAcquisition
    }),
    acquisitionLicensesTaxesPermitsAndFees: new AcquisitionLicensesTaxesPermitsAndFees({
      ...storedPurchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees
    }),
    prePaidAssetsNeeded: new PrePaidAssetNeeded({
      ...storedPurchaserAcquisitionExpenses.prePaidAssetsNeeded
    }),
    workingCapitalNeededAtClosing: new WorkingCapitalNeededAtClosing({
      ...storedPurchaserAcquisitionExpenses.workingCapitalNeededAtClosing
    })
  })

  // General Acquisition
  if (generalAcquisition?.attorneyFees || generalAcquisition?.attorneyFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.attorneyFees = generalAcquisition.attorneyFees
  }
  if (generalAcquisition?.escrowServiceFees || generalAcquisition?.escrowServiceFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.escrowServiceFees = generalAcquisition.escrowServiceFees
  }
  if (generalAcquisition?.appraisalFees || generalAcquisition?.appraisalFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.appraisalFees = generalAcquisition.appraisalFees
  }
  if (generalAcquisition?.accountantsFees || generalAcquisition?.accountantsFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.accountantsFees = generalAcquisition.accountantsFees
  }
  if (generalAcquisition?.franchiseLicenseAgreementTransferFees || generalAcquisition?.franchiseLicenseAgreementTransferFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.franchiseLicenseAgreementTransferFees = generalAcquisition.franchiseLicenseAgreementTransferFees
  }
  if (generalAcquisition?.businessBrokerageFees || generalAcquisition?.businessBrokerageFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.businessBrokerageFees = generalAcquisition.businessBrokerageFees
  }
  if (generalAcquisition?.fillingsRecordingFees || generalAcquisition?.fillingsRecordingFees == "") {
    purchaserAcquisitionExpenses.generalAcquisition.fillingsRecordingFees = generalAcquisition.fillingsRecordingFees
  }

  // Acquisition Licenses, Taxes, Permits & Fees (Expenses)?
  if (acquisitionLicensesTaxesPermitsAndFees?.salesTaxOnEquipmentPurchased || acquisitionLicensesTaxesPermitsAndFees?.salesTaxOnEquipmentPurchased == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.salesTaxOnEquipmentPurchased = acquisitionLicensesTaxesPermitsAndFees.salesTaxOnEquipmentPurchased
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.correctionOfCodeViolations || acquisitionLicensesTaxesPermitsAndFees?.correctionOfCodeViolations == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.correctionOfCodeViolations = acquisitionLicensesTaxesPermitsAndFees.correctionOfCodeViolations
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.franchisorTrainingExpenses || acquisitionLicensesTaxesPermitsAndFees?.franchisorTrainingExpenses == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.franchisorTrainingExpenses = acquisitionLicensesTaxesPermitsAndFees.franchisorTrainingExpenses
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.liquorLicense || acquisitionLicensesTaxesPermitsAndFees?.liquorLicense == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.liquorLicense = acquisitionLicensesTaxesPermitsAndFees.liquorLicense
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.cityCountyAndStateBusinessLicensesAndPermits || acquisitionLicensesTaxesPermitsAndFees?.cityCountyAndStateBusinessLicensesAndPermits == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.cityCountyAndStateBusinessLicensesAndPermits = acquisitionLicensesTaxesPermitsAndFees.cityCountyAndStateBusinessLicensesAndPermits
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.loanFeesForThirdPartyPurchaseLoan || acquisitionLicensesTaxesPermitsAndFees?.loanFeesForThirdPartyPurchaseLoan == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.loanFeesForThirdPartyPurchaseLoan = acquisitionLicensesTaxesPermitsAndFees.loanFeesForThirdPartyPurchaseLoan
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.deferredMaintenanceExpenses || acquisitionLicensesTaxesPermitsAndFees?.deferredMaintenanceExpenses == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.deferredMaintenanceExpenses = acquisitionLicensesTaxesPermitsAndFees.deferredMaintenanceExpenses
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.vehicleRegistrationAndLicensingFees || acquisitionLicensesTaxesPermitsAndFees?.vehicleRegistrationAndLicensingFees == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.vehicleRegistrationAndLicensingFees = acquisitionLicensesTaxesPermitsAndFees.vehicleRegistrationAndLicensingFees
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.travelExpenses || acquisitionLicensesTaxesPermitsAndFees?.travelExpenses == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.travelExpenses = acquisitionLicensesTaxesPermitsAndFees.travelExpenses
  }
  if (acquisitionLicensesTaxesPermitsAndFees?.prepaidPropertyDamageAndLiabilityInsurancePremiums || acquisitionLicensesTaxesPermitsAndFees?.prepaidPropertyDamageAndLiabilityInsurancePremiums == "") {
    purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees.prepaidPropertyDamageAndLiabilityInsurancePremiums = acquisitionLicensesTaxesPermitsAndFees.prepaidPropertyDamageAndLiabilityInsurancePremiums
  }

  //  (Pre-Paid) Assets Needed
  if (prePaidAssetsNeeded?.leaseDeposit || prePaidAssetsNeeded?.leaseDeposit == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.leaseDeposit = prePaidAssetsNeeded.leaseDeposit
  }
  if (prePaidAssetsNeeded?.utilityCompanyDeposit || prePaidAssetsNeeded?.utilityCompanyDeposit == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.utilityCompanyDeposit = prePaidAssetsNeeded.utilityCompanyDeposit
  }
  if (prePaidAssetsNeeded?.productLiabilityAndComprehensiveInsurancePrepayment || prePaidAssetsNeeded?.productLiabilityAndComprehensiveInsurancePrepayment == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.productLiabilityAndComprehensiveInsurancePrepayment = prePaidAssetsNeeded.productLiabilityAndComprehensiveInsurancePrepayment
  }
  if (prePaidAssetsNeeded?.workersCompensationInsurancePrepayment || prePaidAssetsNeeded?.workersCompensationInsurancePrepayment == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.workersCompensationInsurancePrepayment = prePaidAssetsNeeded.workersCompensationInsurancePrepayment
  }
  if (prePaidAssetsNeeded?.prepaidDeposits || prePaidAssetsNeeded?.prepaidDeposits == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.prepaidDeposits = prePaidAssetsNeeded.prepaidDeposits
  }
  if (prePaidAssetsNeeded?.prepaidExpenses || prePaidAssetsNeeded?.prepaidExpenses == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.prepaidExpenses = prePaidAssetsNeeded.prepaidExpenses
  }
  if (prePaidAssetsNeeded?.liquorLicense || prePaidAssetsNeeded?.liquorLicense == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.liquorLicense = prePaidAssetsNeeded.liquorLicense
  }
  if (prePaidAssetsNeeded?.landlordBond || prePaidAssetsNeeded?.landlordBond == "") {
    purchaserAcquisitionExpenses.prePaidAssetsNeeded.landlordBond = prePaidAssetsNeeded.landlordBond
  }

  //  Working Capital Needed at Closing
  if (workingCapitalNeededAtClosing?.operatingCash || workingCapitalNeededAtClosing?.operatingCash == "") {
    purchaserAcquisitionExpenses.workingCapitalNeededAtClosing.operatingCash = workingCapitalNeededAtClosing.operatingCash
  }
  if (workingCapitalNeededAtClosing?.accountsReceivable || workingCapitalNeededAtClosing?.accountsReceivable == "") {
    purchaserAcquisitionExpenses.workingCapitalNeededAtClosing.accountsReceivable = workingCapitalNeededAtClosing.accountsReceivable
  }
  if (workingCapitalNeededAtClosing?.inventory || workingCapitalNeededAtClosing?.inventory == "") {
    purchaserAcquisitionExpenses.workingCapitalNeededAtClosing.inventory = workingCapitalNeededAtClosing.inventory
  }

  dispatch({
    type: actionType,
    payload: new PurchaserAcquisitionExpenses({
      generalAcquisition: new GeneralAcquisition({
      ...purchaserAcquisitionExpenses.generalAcquisition
      }),
      acquisitionLicensesTaxesPermitsAndFees: new AcquisitionLicensesTaxesPermitsAndFees({
        ...purchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees
      }),
      prePaidAssetsNeeded: new PrePaidAssetNeeded({
        ...purchaserAcquisitionExpenses.prePaidAssetsNeeded
      }),
      workingCapitalNeededAtClosing: new WorkingCapitalNeededAtClosing({
        ...purchaserAcquisitionExpenses.workingCapitalNeededAtClosing
      })
    })
  })
}

export const addCustomFieldToPurchaseAcquisitionExpenses = ({ purchaserAcquisitionExpensesType }, {
  section
}) => (dispatch) => {
  const { stockPurchaserAcquisitionExpenses, assetPurchaserAcquisitionExpenses } = store.getState().acquisitionExpenses
  const storedPurchaserAcquisitionExpenses = purchaserAcquisitionExpensesType === "stock" ? ({
    ...stockPurchaserAcquisitionExpenses
  }) : { ...assetPurchaserAcquisitionExpenses }

  storedPurchaserAcquisitionExpenses[section].customFields = [
    ...storedPurchaserAcquisitionExpenses[section].customFields,
    new CustomField({})
  ]

  const actionType = purchaserAcquisitionExpensesType === "stock" ? (
    SET_STOCK_PURCHASER_ACQUISITION_EXPENSES
  ) : SET_ASSET_PURCHASER_ACQUISITION_EXPENSES


  dispatch({
    type: actionType,
    payload: new PurchaserAcquisitionExpenses({
      generalAcquisition: new GeneralAcquisition({
        ...storedPurchaserAcquisitionExpenses.generalAcquisition
      }),
      acquisitionLicensesTaxesPermitsAndFees: new AcquisitionLicensesTaxesPermitsAndFees({
        ...storedPurchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees
      }),
      prePaidAssetsNeeded: new PrePaidAssetNeeded({
        ...storedPurchaserAcquisitionExpenses.prePaidAssetsNeeded
      }),
      workingCapitalNeededAtClosing: new WorkingCapitalNeededAtClosing({
        ...storedPurchaserAcquisitionExpenses.workingCapitalNeededAtClosing
      })
    })
  })
}

export const updateCustomFieldOnProceedsWorksheet = ({ purchaserAcquisitionExpensesType }, {
  section,
  customFields
}) => (dispatch) => {
  const { stockPurchaserAcquisitionExpenses, assetPurchaserAcquisitionExpenses } = store.getState().acquisitionExpenses
  const storedPurchaserAcquisitionExpenses = purchaserAcquisitionExpensesType === "stock" ? ({
    ...stockPurchaserAcquisitionExpenses
  }) : { ...assetPurchaserAcquisitionExpenses }

  const actionType = purchaserAcquisitionExpensesType === "stock" ? (
    SET_STOCK_PURCHASER_ACQUISITION_EXPENSES
  ) : SET_ASSET_PURCHASER_ACQUISITION_EXPENSES

  storedPurchaserAcquisitionExpenses[section].customFields = customFields

  dispatch({
    type: actionType,
    payload: new PurchaserAcquisitionExpenses({
      generalAcquisition: new GeneralAcquisition({
        ...storedPurchaserAcquisitionExpenses.generalAcquisition
      }),
      acquisitionLicensesTaxesPermitsAndFees: new AcquisitionLicensesTaxesPermitsAndFees({
        ...storedPurchaserAcquisitionExpenses.acquisitionLicensesTaxesPermitsAndFees
      }),
      prePaidAssetsNeeded: new PrePaidAssetNeeded({
        ...storedPurchaserAcquisitionExpenses.prePaidAssetsNeeded
      }),
      workingCapitalNeededAtClosing: new WorkingCapitalNeededAtClosing({
        ...storedPurchaserAcquisitionExpenses.workingCapitalNeededAtClosing
      })
    })
  })
}